(function () {
  // Immediately fetch the metafield color hex value
  var customVariantColorElement = document.getElementById(
    "custom-variant-color-hex"
  );
  var colorHex = customVariantColorElement
    ? customVariantColorElement.getAttribute("data-color-hex")
    : null;

  if (colorHex) {
    // Function to calculate brightness of a color
    var getBrightness = function (hex) {
      var rgb = hex
        .replace("#", "")
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16));
      return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000; // Weighted formula
    };

    // Apply the color to elements already present
    var announcementBarWrapper = document.querySelector(
      ".shopify-section--announcement-bar"
    );
    var announcementBarIcons = document.querySelectorAll(
      ".shopify-section--announcement-bar .tap-area"
    );
    var announcementBar = document.querySelector(".announcement-bar");
    var header = document.querySelector(".header");

    if (announcementBar) {
      announcementBar.style.setProperty(
        "background-color",
        colorHex,
        "important"
      );
      announcementBarIcons.forEach(function (icon) {
        icon.style.color = colorHex;
      });

      // Adjust text color based on brightness
      var brightness = getBrightness(colorHex);
      if (brightness > 186) {
        // Light background
        announcementBar.style.setProperty("color", "#000", "important"); // Black text
      } else {
        // Dark background
        announcementBar.style.setProperty("color", "#FFF", "important"); // White text
      }

      if (colorHex == "#FFFFFF") {
        announcementBarWrapper.style.removeProperty("margin-bottom");
        announcementBar.style.removeProperty("border-bottom");
        if (header) {
          header.style.setProperty("border-top", "1px solid #dcdcdc", "important");
        }
      } else {
        announcementBar.style.removeProperty("border-bottom");
        if (header) {
          header.style.removeProperty("border-top");
        }
      }
    }

    var addToCartButton = document.querySelector("button#AddToCart");
    var buttonText = addToCartButton.querySelector(".loader-button__text");
    if (addToCartButton) {
      addToCartButton.style.setProperty(
        "background-color",
        colorHex,
        "important"
      );
      // Adjust text color based on brightness
      var brightness = getBrightness(colorHex);
      if (brightness > 186) {
        buttonText.style.setProperty("color", "#000");
        if (colorHex == "#FFFFFF") {
          addToCartButton.style.setProperty("border", "1px solid #000");
        }
      } else {
        buttonText.style.setProperty("color", "#FFF");
        if (colorHex == "#FFFFFF") {
          addToCartButton.style.setProperty("border", "1px solid #000");
        }
      }
    }

    var updateSwatchBackground = function () {
      var swatchItems = document.querySelectorAll(".block-swatch__item");
      swatchItems.forEach(function (item) {
        var radio = item.previousElementSibling;
        if (radio && radio.checked) {
          item.style.setProperty("background-color", colorHex, "important");
          // Adjust text color based on brightness
          var brightness = getBrightness(colorHex);
          if (brightness > 186) {
            item.style.setProperty("color", "#000");
          } else {
            item.style.setProperty("color", "#FFF");
          }
        } else {
          item.style.removeProperty("background-color");
          item.style.removeProperty("color");
        }
      });
    };

    updateSwatchBackground();

    // Observe for changes in the swatch items
    var swatchObserver = new MutationObserver(updateSwatchBackground);
    swatchObserver.observe(document.body, { childList: true, subtree: true });

    // Listen for change events on radios
    document.addEventListener("change", function (event) {
      if (event.target.matches(".block-swatch__radio")) {
        updateSwatchBackground();
      }
    });

    // Observe for the AddToCart button if it appears later
    var observer = new MutationObserver(function (mutationsList, observer) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === "childList") {
          var newAddToCartButton = document.querySelector("button#AddToCart");
          if (newAddToCartButton) {
            newAddToCartButton.style.setProperty(
              "background-color",
              colorHex,
              "important"
            );
            // Adjust text color based on brightness
            var brightness = getBrightness(colorHex);
            if (brightness > 186) {
              newAddToCartButton.querySelector(".loader-button__text").style.setProperty("color", "#000");
              if (colorHex == "#FFFFFF") {
                newAddToCartButton.style.setProperty("border", "1px solid #000");
              }
            } else {
              newAddToCartButton.querySelector(".loader-button__text").style.setProperty("color", "#FFF");
              if (colorHex == "#FFFFFF") {
                newAddToCartButton.style.setProperty("border", "1px solid #000");
              }
            }
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    console.warn(
      "data-color-hex attribute not found on #custom-variant-color-hex element."
    );
  }
})();
